export const PageDataState = {
    Searchs: {
        types: {
            type: 'select',
            id: 'types',
            label: 'ระดับสิทธิ์',
            value: '',
            placeholder: 'ระดับสิทธิ์',
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา',
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            placeholder: 'ผู้ประกอบการ',
        },
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ นามสกุล',
            value: '',
            placeholder: 'ชื่อ นามสกุล',
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            placeholder: 'อีเมล',
        },
        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            placeholder: 'เบอร์ติดต่อ',
        },
        username: {
            type: 'text',
            id: 'username',
            label: 'บัญชีผู้ใช้',
            value: '',
            placeholder: 'บัญชีผู้ใช้',
        },
        status: {
            type: 'text',
            id: 'status',
            label: 'สถานะ',
            value: '',
            placeholder: 'สถานะ',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ นามสกุล',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        types: {
            type: 'select',
            id: 'types',
            label: 'ระดับสิทธิ์',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        subtypes: {
            type: 'select',
            id: 'subtypes',
            label: 'ตำแหน่งย่อย',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        enterprise_id: {
            type: 'select',
            id: 'enterprise_id',
            label: 'ผู้ประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        contact: {
            type: 'text',
            id: 'contact',
            label: 'เบอร์ติดต่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 9,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        username: {
            type: 'text',
            id: 'username',
            label: 'บัญชีผู้ใช้',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 100
            },
            error: { status: null, msg: '' }
        },
        password: {
            type: 'password',
            id: 'password',
            label: 'รหัสผ่าน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 8,
                maxLength: 100
            },
            error: { status: null, msg: '' }
        },
        new_password: {
            type: 'password',
            id: 'new_password',
            label: 'รหัสผ่านใหม่',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 8,
                maxLength: 100
            },
            error: { status: null, msg: '' }
        },
        profile_img: {
            type: 'file',
            id: 'profile_img',
            label: 'รูปภาพโปรไฟล์',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: true,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}